import React from 'react';
import { ModelProvider } from '../contexts/modelContextNew';


interface IProps {
  children: React.ReactElement,
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void,
  model?: any,
  emptyClearStates?: Record<string, any>;
}

const Form = ({ children, onSubmit, model, emptyClearStates }: IProps) => {

  const executeValidation = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (onSubmit) {
      onSubmit(event);
    }
  };

  return (
    <ModelProvider model={model} emptyClearStates={emptyClearStates} >
      <form onSubmit={executeValidation} noValidate>
        { children }
      </form>
    </ModelProvider>
  );
};

export default Form;